// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8c-4";
export var collapsed = "_8c-1";
export var headerBar = "_8c-0";
export var leftHeaderContent = "_8c-3";
export var subjectContainer = "_8c-2";